// extracted by mini-css-extract-plugin
module.exports = {"theme_switch":"SwitchTheme_theme_switch__4nNgV"};